import { render, staticRenderFns } from "./HasFriendsOnMap.vue?vue&type=template&id=721557ad&scoped=true"
import script from "./HasFriendsOnMap.vue?vue&type=script&lang=js"
export * from "./HasFriendsOnMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721557ad",
  null
  
)

export default component.exports